import { Clickable, Col, H3, P, Row, Section, Wrapper } from '@ahmdigital/ui';

import Banner from '../../elements/banner';
import constants from '../../ahm-constants';
import Head from '../../../utils/head';
import LegacyBorderedWrapper from '../../components/legacy-bordered-wrapper';
import textStyles from '../../application/common/text.module.sass';

const loggingInLink = <Clickable to={constants.URLS.MEMBERS.LOGIN}>logging in</Clickable>;

const DirectDebitRequestPage = () => (
  <LegacyBorderedWrapper>
    <div className={textStyles.text}>
      <Head>
        <title>Direct Debit Request Service Agreement</title>
        <meta
          name="description"
          content="All the info you need about our Direct Debit Request (DDR) Service Agreement."
        />
      </Head>
      <Banner title="Direct Debit Request Service Agreement" />
      <Section variant="large">
        <Wrapper>
          <Row>
            <Col sm={12} df={8}>
              <P>
                ahm health insurance is a business of Medibank Private Ltd ABN 47 080 890 259. ‘ahm health insurance’
                and ‘ahm’ are references to Medibank Private Ltd trading as ahm health insurance. ahm issues this Direct
                Debit Request Service Agreement.
              </P>
              <P>
                For the purposes of this agreement, our ‘HandyPay’ and ‘Direct Debit’ authority is considered the same
                as a Direct Debit Request Service Agreement.
              </P>
              <H3>Our commitment to you</H3>
              <ol>
                <li>
                  ahm will give you at least 14 days’ notice in writing if there are changes to the terms of the drawing
                  arrangements.
                </li>
                <li>
                  ahm will keep information relating to your nominated financial institution account confidential except
                  where required for the purposes of conducting direct debits with your financial institution.
                </li>
                <li>
                  Where the due date is not a business day, ahm will draw from your nominated account on the nearest
                  business day.
                </li>
                <li>ahm will at all times attempt to meet the scheduled drawing date as arranged with you.</li>
              </ol>
              <H3>Your commitment to us</H3>
              {/* @ts-expect-error - Automatic, Please fix when editing this file */}
              <ol start="5">
                <li>To ensure that your nominated account can accept direct debits.</li>
                <li>To advise us if the nominated account is transferred or closed, or the account details change.</li>
                <li>To arrange another payment method if ahm cancels the drawing arrangements.</li>
              </ol>
              <H3>Your rights</H3>
              {/* @ts-expect-error - Automatic, Please fix when editing this file */}
              <ol start="8">
                <li>
                  Subject to the Terms & Conditions of your ahm policy or account, you may alter the drawing
                  arrangements in writing. Such written advice must be received by us at least 7 working days before the
                  next draw date for any of the following:
                  <ul>
                    <li> stopping an individual drawing</li>
                    <li> deferring a drawing</li>
                    <li> altering your Direct Debit information in any way</li>
                    <li> cancelling the drawings completely.</li>
                  </ul>
                </li>
                <li>
                  Subject to the Terms & Conditions of your ahm policy or account, you may alter the drawing
                  arrangements by telephone. Alterations to Direct Debit information can be made by verbal agreement
                  between ahm and the member no less than 3 working days before the next draw date. ahm will send you
                  written correspondence to confirm the alterations.
                </li>
                <li>
                  Where you consider that a drawing has been initiated incorrectly, you should get in touch with ahm as
                  soon as possible. Where you are not happy with our response, you can address a formal complaint with
                  the envelope marked ‘Notice of Complaint’ to: {constants.CONTACT.ADDRESS.POSTAL}.
                </li>
              </ol>
              <H3>Other information</H3>
              {/* @ts-expect-error - Automatic, Please fix when editing this file */}
              <ol start="11">
                <li>You can view the details of your direct debit arrangement by {loggingInLink} to your account.</li>
                <li>
                  If your nominated account is a debit or credit card, you authorise us to continue to process debits
                  under your Direct Debit Request after the expiry date shown on your nominated debit or credit card.
                </li>
                <li>
                  ahm reserves the right to ask that instructions from a member to stop or in any way alter the drawing
                  details is given to us in writing in your cover certificate or change of cover confirmation letter.
                </li>
                <li>
                  ahm reserves the right to cancel your drawing arrangement if drawings are dishonoured by your
                  financial institution, and to ask you to arrange an alternative payment method.
                </li>
                <li>
                  Your drawing arrangements are also governed by the terms and conditions of your ahm health insurance
                  policy or account.
                </li>
              </ol>
            </Col>
          </Row>
        </Wrapper>
      </Section>
    </div>
  </LegacyBorderedWrapper>
);

export default DirectDebitRequestPage;
